import { AsyncPipe, NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store, select } from '@ngrx/store';
import axios from 'axios';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Article } from '../../../../models/article.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { AppState } from '../../../../state/appstate';
import * as articleSelector from '../../../../state/selectors/article.selector';
import { TextEditorComponent } from '../../../components/text-editor/text-editor.component';

@Component({
  selector: 'app-my-article',
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    RouterLink,
    NgxSkeletonLoaderModule,
    TextEditorComponent,
    InitialsPipe,
  ],
  templateUrl: './my-article.component.html',
  styleUrls: ['./my-article.component.css'],
})
export class MyArticleComponent implements OnInit {
  @ViewChild('textEditor', { static: false }) textEditor!: TextEditorComponent;

  route: ActivatedRoute = inject(ActivatedRoute);
  toastr: any = inject(ToastrService);

  articleId: string | null = this.route.snapshot.paramMap.get('id');

  article$: Observable<Article | null | undefined> = new Observable();

  loading: boolean = true;

  constructor(
    private store: Store<AppState>,
    private http: HttpClient,
    private router: Router,
  ) {
    if (this.articleId != null) {
      this.article$ = this.store.pipe(
        select(articleSelector.getArticleById(this.articleId)),
      );
    }
  }

  ngOnInit(): void {
    this.article$.subscribe(async (article) => {
      this.loading = false;
      await this.getArticle(article?.link!)
        .then(async (data) => {
          // await this.loadData(data);
          this.loading = false;
        })
        .catch((error) => {
          this.toastr.error(
            'Error occurred while trying to fetch the article from our servers. Please try again later.',
            'Error fetching article',
          );
          this.loading = false;
        });
    });
  }

  async getArticle(url: string) {
    return axios.get(url).then((response) => response.data);
  }
}
